export default "__VITE_ASSET__CHOA3h_v__"